export default "__VITE_ASSET__DrmnGG5g__"